import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2M9.222 11.444c0 .89-.778 1.667-1.666 1.667H6.444v2.222H4.778V8.667h2.778c.888 0 1.666.777 1.666 1.666zm5.556 2.223c0 .889-.778 1.666-1.667 1.666h-2.778V8.667h2.778c.889 0 1.667.777 1.667 1.666zm4.444-3.334h-1.666v1.111h1.666v1.667h-1.666v2.222h-1.667V8.667h3.333zm-7.222 0h1.111v3.334H12zm-5.556 0h1.112v1.111H6.444z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }